import WidgetSection from "./sections/widgetSection";
import ThemeAppearanceSection from "./sections/themeAppearanceSection";
import { ExportSection, ImportConfigSection, } from "./sections/configTransferSection";
import { DockLayoutSection, DrawerLayoutSection, FooterLayoutSection, HeaderLayoutSection, MainContentLayoutSection, MainMenuLayoutSection, } from "./sections/layoutGridSection";
import ButtonStylesSection from "./sections/buttonStylesSection";
import DetailViewLayoutSection from "./sections/detailViewLayoutSection";
import TabsAndSubpanelSection from "./sections/tabsAndSubpanelSection";
import TextTypographySection from "./sections/textTypographySection";
import DistinctColorGeneratorSection from "./sections/distinctColorGeneratorSection";
export var sectionComponents = {
    export: ExportSection,
    import: ImportConfigSection,
    widget: WidgetSection,
    base: ThemeAppearanceSection,
    "distinct-color": DistinctColorGeneratorSection,
    header: HeaderLayoutSection,
    menu: MainMenuLayoutSection,
    dock: DockLayoutSection,
    drawer: DrawerLayoutSection,
    main: MainContentLayoutSection,
    footer: FooterLayoutSection,
    button: ButtonStylesSection,
    "detail-view": DetailViewLayoutSection,
    text: TextTypographySection,
    tabs: TabsAndSubpanelSection,
    // ajoutez ici au fur et à mesure : header, menu, dock, drawer, main, button, text, tabs, footer
};
